var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 102,
    viewBox: "0 0 91 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2162 5.59059C43.0645 3.36873 47.8059 3.36873 51.6543 5.59059L81.6514 22.9094C85.4998 25.1313 87.8705 29.2375 87.8705 33.6812V68.3188C87.8705 72.7626 85.4998 76.8687 81.6514 79.0906L51.6543 96.4094C47.8059 98.6313 43.0645 98.6313 39.2162 96.4094L9.21908 79.0906C5.3707 76.8687 3 72.7626 3 68.3188V33.6812C3 29.2375 5.3707 25.1313 9.21908 22.9094L39.2162 5.59059Z",
    fill: "#4374A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1543 2.99251L83.1514 20.3113C87.928 23.0691 90.8705 28.1657 90.8705 33.6812V68.3188C90.8705 73.8344 87.928 78.9309 83.1514 81.6887L53.1543 99.0075C48.3777 101.765 42.4927 101.765 37.7162 99.0075L7.71908 81.6887C2.9425 78.9309 0 73.8344 0 68.3188V33.6812C0 28.1657 2.9425 23.0691 7.71908 20.3113L37.7162 2.99252C42.4927 0.234755 48.3777 0.234754 53.1543 2.99251ZM51.6543 5.59059C47.8059 3.36873 43.0645 3.36873 39.2162 5.59059L9.21908 22.9094C5.3707 25.1313 3 29.2375 3 33.6812V68.3188C3 72.7626 5.3707 76.8687 9.21908 79.0906L39.2162 96.4094C43.0645 98.6313 47.8059 98.6313 51.6543 96.4094L81.6514 79.0906C85.4998 76.8687 87.8705 72.7626 87.8705 68.3188V33.6812C87.8705 29.2375 85.4998 25.1313 81.6514 22.9094L51.6543 5.59059Z",
    fill: "#4374A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2162 5.59059C43.0645 3.36873 47.8059 3.36873 51.6543 5.59059L81.6514 22.9094C85.4998 25.1313 87.8705 29.2375 87.8705 33.6812V68.3188C87.8705 72.7626 85.4998 76.8687 81.6514 79.0906L51.6543 96.4094C47.8059 98.6313 43.0645 98.6313 39.2162 96.4094L9.21908 79.0906C5.3707 76.8687 3 72.7626 3 68.3188V33.6812C3 29.2375 5.3707 25.1313 9.21908 22.9094L39.2162 5.59059Z",
    fill: "#87E1FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1514 25.5075L50.1543 8.18867C47.2341 6.5027 43.6363 6.5027 40.7162 8.18867L10.7191 25.5075C7.7989 27.1935 6 30.3093 6 33.6812V68.3188C6 71.6908 7.7989 74.8066 10.7191 76.4925L40.7162 93.8113C43.6363 95.4973 47.2341 95.4973 50.1543 93.8113L80.1514 76.4925C83.0716 74.8066 84.8705 71.6908 84.8705 68.3188V33.6812C84.8705 30.3093 83.0716 27.1935 80.1514 25.5075ZM51.6543 5.59059C47.8059 3.36873 43.0645 3.36873 39.2162 5.59059L9.21908 22.9094C5.3707 25.1313 3 29.2375 3 33.6812V68.3188C3 72.7626 5.3707 76.8687 9.21908 79.0906L39.2162 96.4094C43.0645 98.6313 47.8059 98.6313 51.6543 96.4094L81.6514 79.0906C85.4998 76.8687 87.8705 72.7626 87.8705 68.3188V33.6812C87.8705 29.2375 85.4998 25.1313 81.6514 22.9094L51.6543 5.59059Z",
    fill: "#FFFBF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_17126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9968 31.3353L57.19 69.7599L56.2368 70.0624L44.9971 34.6422L33.763 70.0623L32.8098 69.76L44.9968 31.3353Z",
    fill: "#4374A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7509 52.7428H39.1956V49.7428H50.7509V52.7428Z",
    fill: "#D8367D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_17126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 38,
    fill: "white",
    transform: "translate(30 32)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperA);
export default __webpack_public_path__ + "static/media/UPPER_A.930d08fefa86b58e3a813905a337ece0.svg";
export { ForwardRef as ReactComponent };